/* global payuAffordability */
import React, { useEffect } from "react";
function AffordabilityWidget({ payuKey, amount }) {
  function loadWidget() {
    payuAffordability.init({
      key: payuKey,
      amount: amount,
      selector: "#payuWidget",  
    });
  }

  function appendScript() {
    let script = document.getElementById("payu-affordability-widget");

    if (!script) {
      script = document.createElement("script");
      script.src = "https://jssdk.payu.in/widget/affordability-widget.min.js";
      script.id = "payu-affordability-widget";
      document.body.appendChild(script);
    }

    script.addEventListener("load", loadWidget, { once: true });
  }

  useEffect(() => {
    appendScript();
    //eslint-disable-next-line
  }, []);

  return <div id="payuWidget" />;
}

export default AffordabilityWidget;
